import React from 'react';
import { Link } from 'react-router-dom';
import { ChefHat, Twitter, Instagram, Linkedin, Github } from 'lucide-react';

const Footer: React.FC = () => {
    return (
        <footer className="py-20 px-6 bg-background border-t border-white/5">
            <div className="max-w-[1400px] mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-20">
                    <div className="col-span-1 space-y-6">
                        <div className="flex items-center gap-2">
                            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                                <ChefHat className="w-5 h-5 text-white" />
                            </div>
                            <span className="text-xl font-bold text-white tracking-tight">Garçom Digital</span>
                        </div>
                        <p className="text-secondary font-medium">
                            Transformando a gestão gastronômica através de design e tecnologia.
                        </p>
                        <div className="flex gap-4">
                            {[Twitter, Instagram, Linkedin, Github].map((Icon, i) => (
                                <div key={i} className="p-2 rounded-lg bg-white/5 text-white/40 hover:text-primary hover:bg-white/10 transition-all cursor-pointer">
                                    <Icon className="w-5 h-5" />
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="space-y-6">
                        <h4 className="text-white font-bold uppercase tracking-widest text-xs">Produto</h4>
                        <ul className="space-y-4 text-secondary font-medium">
                            <li className="hover:text-primary transition-colors cursor-pointer">Recursos</li>
                            <li className="hover:text-primary transition-colors cursor-pointer">Integrações</li>
                            <li className="hover:text-primary transition-colors cursor-pointer">Segurança</li>
                            <li className="hover:text-primary transition-colors cursor-pointer">Changelog</li>
                        </ul>
                    </div>

                    <div className="space-y-6">
                        <h4 className="text-white font-bold uppercase tracking-widest text-xs">Empresa</h4>
                        <ul className="space-y-4 text-secondary font-medium">
                            <li className="hover:text-primary transition-colors cursor-pointer">Sobre nós</li>
                            <li className="hover:text-primary transition-colors cursor-pointer">Carreiras</li>
                            <li className="hover:text-primary transition-colors cursor-pointer">Blog</li>
                            <li className="hover:text-primary transition-colors cursor-pointer">Contato</li>
                        </ul>
                    </div>

                    <div className="space-y-6">
                        <h4 className="text-white font-bold uppercase tracking-widest text-xs">Legal</h4>
                        <ul className="space-y-4 text-secondary font-medium">
                            <li><Link to="/politica-de-privacidade" className="hover:text-primary transition-colors">Privacidade</Link></li>
                            <li><Link to="/termos-de-servico" className="hover:text-primary transition-colors">Termos</Link></li>
                            <li><Link to="/exclusao-de-dados" className="hover:text-primary transition-colors">Exclusao de dados</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="flex flex-col md:flex-row justify-between items-center gap-8 pt-8 border-t border-white/5 text-secondary/40 text-sm font-bold uppercase tracking-widest">
                    <span>© 2026 Garçom Digital software. Todos os direitos reservados.</span>
                    <div className="flex gap-8">
                        <span className="hover:text-white transition-colors cursor-pointer">Status</span>
                        <span className="hover:text-white transition-colors cursor-pointer">Suporte</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
